import React, { useEffect, useState } from "react";
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import { usePatient } from "../../contexts";
import SuccessModal from "../modals/SuccessModal";
import { useNavigate } from "react-router-dom";
import ProcedureTable from "../tables/ProcedureTable";
import { get } from "../../utility/fetch";
import Spinner from "../UI/Spinner";
import Personal from "./Patient/Personal";
import ContactDetails from "./Patient/ContactDetails";
import EmergencyContact from "./Patient/EmergencyContact";
import ClientList from "../layouts/ClientList";
import { HiPlus } from "react-icons/hi";
import notification from "../../utility/notification";
import WalkInTable from "../tables/WalkInTable";
import Paginated from "../layouts/MUIPagination";
import LabReportTable from "../modals/LabReports";

function ManageProcedures() {
  const [allPatients, setAllPatients] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [admit, setAdmit] = useState('appointment');
  const [appointment, setAppointment] = useState(false);
  const { patientId, patientName, patientInfo, nurseRoles } = usePatient();
  const [selectedTab, setSelectedTab] = useState('referral');
  const [combinedData, setCombinedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [allWalkIn, setAllWalkIn] = useState([]);

  const [admittedPatient, setAdmittedPatients] = useState([]);
  const [lgas, setLgas] = useState([]);
  const [view, setView] = useState("notexisting");

  const [pageSize] = useState(10);
  const [referredCount, setReferredCount] = useState(0);
  const [walkInCount, setWalkInCount] = useState(0);
  const [referredPages, setReferredPages] = useState(1);
  const [walkInPages, setWalkInPages] = useState(1);

  // NEW: incomplete procedures state
  const [allIncomplete, setAllIncomplete] = useState([]);
  const [incompleteCount, setIncompleteCount] = useState(0);
  const [incompletePages, setIncompletePages] = useState(1);

  const handlePageChange = (newPage) => {
    setReferredPages(newPage);
  };

  const getReferredPatients = async () => {
    setLoading(true);
    try {
      // use referral-specific endpoints as requested
      // endpoint: /patientlabreport/internal-lab-report/list/{pageNumber}/to-be-approved-by-user
      const page = referredPages || 1;
      let res = await get(`/patientlabreport/internal-lab-report/list/${page}/ToBeApprovedByUser`);
      console.log('getReferredPatients:', res);
      if (res?.statusCode === 200) {
        setAllPatients(res?.data?.recordList || []);
        setReferredCount(res?.data?.metadata?.totalItems || 0);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching referred patients:', error);
      setLoading(false);
    }
  };

  const getWalkInPatients = async () => {
    setLoading(true);
    try {
      let res = await get(`/walkinpatientlabreport/list/true/ToBeApprovedByUser?pageNumber=${walkInPages}&pageSize=10`);
      console.log(res)

      if (res?.statusCode === 200) {
        setAllWalkIn(res.data?.recordList || []);
        setWalkInCount(res?.data?.metadata?.totalItems || 0);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching walk-in patients:', error);
      setLoading(false);
    }
  };

  // NEW: fetch incomplete procedures
  const getIncompletePatients = async () => {
    setLoading(true);
    try {
      let res = await get(`/walkinpatientlabreport/list/${incompletePages}/10`);

      if (res?.statusCode === 200) {
        setAllIncomplete(res.data?.recordList || []);
        setIncompleteCount(res?.data?.metadata?.totalItems || 0);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching incomplete patients:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getReferredPatients();
  }, [referredPages]);

  useEffect(() => {
    getWalkInPatients();
  }, [walkInPages]);

  // NEW: effect for incomplete procedures
  useEffect(() => {
    getIncompletePatients();
  }, [incompletePages]);

  const renderTabContent = (selectedTab) => {
    switch (selectedTab) {
      case "referral":
        return (
          <>
            {loading ? (
              <div className="w-100 flex flex-h-center">
                <Spinner />
              </div>
            ) : (
              <ProcedureTable 
                getProcedures={getReferredPatients} 
                data={allPatients} 
                readOnly={false} 
                manage={true}
              />
            )}
            <Paginated
              count={referredCount}
              page={referredPages}
              onPageChange={handlePageChange}
              pageSize={10}
            />
          </>
        );
      case "walkin":
        return (
          <>
            {loading ? (
              <div className="w-100 flex flex-h-center">
                <Spinner />
              </div>
            ) : (
              <WalkInTable
                getProcedures={getWalkInPatients} 
                data={allWalkIn} 
                readOnly={false} 
                manage={true}
              />
            )}
            <Paginated
              count={walkInCount}
              page={walkInPages}
              onPageChange={setWalkInPages}
              pageSize={10}
            />
          </>
        );
      case "incomplete":
        return (
          <>
            {loading ? (
              <div className="w-100 flex flex-h-center">
                <Spinner />
              </div>
            ) : (
              <WalkInTable 
                getProcedures={getIncompletePatients} 
                data={allIncomplete} 
                readOnly={false} 
              />
            )}
            <Paginated
              count={incompleteCount}
              page={incompletePages}
              onPageChange={setIncompletePages}
              pageSize={10}
            />
          </>
        );
      case "contact":
        return <ContactDetails setSelectedTab={setSelectedTab} hide={true} renderTabContent={renderTabContent} />;
      case "emergency":
        return <EmergencyContact renderTabContent={renderTabContent} />;
      case "medicalRecord":
        return null;
      default:
        return <Personal setSelectedTab={setSelectedTab} renderTabContent={renderTabContent} />;
    }
  };

  return (
    <div className="w-100 m-t-40">
      <div className="tabs m-t-20 bold-text">
        <>
          <div
            className={`tab-item ${selectedTab === "referral" ? "active" : ""}`}
            onClick={() => setSelectedTab("referral")}
          >
           Review Referral Procedures
          </div>
          <div
            className={`tab-item ${selectedTab === "walkin" ? "active" : ""}`}
            onClick={() => setSelectedTab("walkin")}
          >
            Review Walk-In Procedures
          </div>
        </>
      </div>

      <div>
        {renderTabContent(selectedTab)}
      </div>


       
    </div>
  );
}

export default ManageProcedures;
